
import { defineComponent } from 'vue'
import { smoothScroll } from '@white-label-helper/scroll'
import IconArrow from '@white-label-icon/icon-arrow'
import { dataTestIdScrollTopButton } from './settings'

export default defineComponent({
  name: 'ScrollTopButton',

  components: {
    IconArrow
  },

  methods: {
    dataTestIdScrollTopButton() {
      return dataTestIdScrollTopButton
    },
    scrollToTop () {
      smoothScroll('body')
    }
  }
})
